import React from 'react';

import { ActivityCard } from '@adsk/alloy-react-activity-log';
import { useLocale } from '@adsk/alloy-react-locale';

import { SubmittalsItemDisplay } from './common';
import ReferencePickerPlugin from '../../../types/ReferencePickerPlugin';
import { ACTIVITY_VARIANTS } from '../../constants';
import { SubmittalsItem } from '../types';

const SubmittalsActivityCard: Exclude<
  ReferencePickerPlugin<SubmittalsItem>['ActivityCard'],
  undefined
> = ({ entity, variant, ...rest }) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  const title =
    variant === ACTIVITY_VARIANTS.ADDED
      ? T.translate('ACTIVITY_CARD_TITLE_ADD')
      : T.translate('ACTIVITY_CARD_TITLE_REMOVE');

  return (
    <ActivityCard {...rest} title={title}>
      <SubmittalsItemDisplay item={entity} />
    </ActivityCard>
  );
};

export default SubmittalsActivityCard;
